import { type FC, useContext } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { GetHelpZendeskContext } from './GetHelpZendeskContext.ts';
import { ACTIONS, STEPS } from './GetHelpZendeskConstants.ts';

import { type GetHelpZendeskSellerPopularArticles_viewer$key } from './__generated__/GetHelpZendeskSellerPopularArticles_viewer.graphql.ts';

import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment GetHelpZendeskSellerPopularArticles_viewer on Viewer {
        getHelpSellerCmsTopics: getHelpCmsTopics(isSeller: $isSeller, orderId: $orderId) {
            groupKey
            topics {
                topicKey
                topicLabel
            }
        }
    }
`;

const GetHelpZendeskSellerPopularArticles: FC<{
    viewer: GetHelpZendeskSellerPopularArticles_viewer$key;
}> = ({ viewer: viewerRef }) => {
    const {
        dispatch,
        state: { step },
    } = useContext(GetHelpZendeskContext);

    const viewer = useFragment(viewerFragment, viewerRef);
    const { getHelpSellerCmsTopics } = viewer;
    const popularArticlesGroup = step === STEPS.SELLER_ITEM ? 'items' : 'orders';

    const popularArticles = getHelpSellerCmsTopics?.find(
        group => group?.groupKey === popularArticlesGroup
    );

    if (!popularArticles?.topics?.length) {
        return null;
    }

    return (
        <>
            <div className={dibsCss.sassyFontBodyLargeHeavy}>
                <FormattedMessage
                    id="getHelp.GetHelpZendeskSellerPopularArticles.title"
                    defaultMessage="Popular Articles"
                />
            </div>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    dibsCss.itemsStart,
                    dibsCss.gapYXxsmall,
                    dibsCss.mtXsmall
                )}
            >
                {(popularArticles?.topics || []).map(topic => (
                    <Link
                        key={topic?.topicKey}
                        onClick={() => {
                            if (popularArticlesGroup === 'orders') {
                                dispatch({
                                    type: ACTIONS.SET_ITEM_ID,
                                    itemId: '',
                                });
                            } else {
                                dispatch({
                                    type: ACTIONS.SET_ORDER_ID,
                                    orderId: '',
                                });
                            }

                            dispatch({
                                type: ACTIONS.SET_CMS_TOPIC_KEY,
                                topicKey: topic?.topicKey || '',
                            });
                            dispatch({ type: ACTIONS.SET_STEP, step: STEPS.CMS_TOPIC });
                        }}
                        className={dibsCss.block}
                    >
                        <span className={dibsCss.sassyFontBodyMedium}>{topic?.topicLabel}</span>
                    </Link>
                ))}
            </div>
        </>
    );
};

export { GetHelpZendeskSellerPopularArticles };
